import { removeItem } from "./cooke-data";

export default function clearSession() {
    removeItem("user");
    removeItem("userRole");
    removeItem("permissions");
    removeItem("session_token");
}
